import { render, staticRenderFns } from "./PixFilters.vue?vue&type=template&id=ef773df4"
import script from "./PixFilters.vue?vue&type=script&lang=js"
export * from "./PixFilters.vue?vue&type=script&lang=js"
import style0 from "./PixFilters.vue?vue&type=style&index=0&id=ef773df4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports